import styled from 'styled-components';

export const SpacerElement = styled.span<{ width?: string; height?: string }>`
  display: block;
  width: ${({ width }): string => width ?? '1px'};
  height: ${({ height }): string => height ?? '1px'};
  flex-shrink: 0;
`;
